import {LanguageMinor, CurrencyConvertMinor, CategoriesMajor} from "@shopify/polaris-icons";
import InfoTabTemplate from "../../../../common/components/InfoTab";
import template from "/public/selectors/customization/_1.png";
import {SEL_APP_LINK} from "../../../../../utils/constants";
import useTranslation from "next-translate/useTranslation";
import {SEL_NAMESPACE} from "../../../../../utils/i18nNameSpaces";

const Template = () => {
  const {t} = useTranslation(SEL_NAMESPACE);

  const tempData = {
    header: t(`infoTabs._1.header`),
    subheader: t(`infoTabs._1.subheader`),
    dataList: [
      // t(`infoTabs.template._1`),
      // t(`infoTabs.template._2`),
      // t(`infoTabs.template._3`),
    ],
    iconsList: [
      LanguageMinor,
      CurrencyConvertMinor,
      CategoriesMajor,
    ],
    link: {
      text: t(`infoTabs._1.link.text`),
    }
  }

  return (
    <>
      <InfoTabTemplate tempData={tempData} img={template} link={SEL_APP_LINK} content={"simplified"}/>
    </>
  );
};

export default Template;